var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 600,
    viewBox: "0 0 1400 700",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#060",
    d: "M0 0h1400v700H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1400v500H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M0 0h1400v200H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.334)",
    fill: "#f8c300"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672 340.7a12.5 12.5 0 0 1 23.3 5.9v50h9.4v-50a12.5 12.5 0 0 1 23.3-5.9 29.5 29.5 0 1 0-56 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.7 327.65a20 20 0 0 1 21.3 9.55 20 20 0 0 1 21.3-9.55 21.5 21.5 0 0 0-42.6 0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M695.3 376.627a38 38 0 0 1-63.845 24.316 39.5 39.5 0 0 1-59.734 17.467c3.65 36.426 58.252 28.989 62.32-6.429 17.154 30.115 54.873 21.49 65.91-15.4z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "matrix(-1 0 0 1 1400 0)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M658.84 441.31c-7.618 16.446-22.845 19.271-36.164 5.995 0 0 5.354-3.783 11.086-4.826-1.075-4.574 1.13-10.902 4.235-14.324 3.258 2.227 7.804 6.689 8.96 11.874 8.03-1.04 11.883 1.282 11.883 1.282z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(9.37 700 804)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(18.74 700 804)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 478a340 340 0 0 1 194 0",
    fill: "none",
    strokeWidth: 16,
    stroke: "#f8c300"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700 380)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    transform: "rotate(13.25) scale(.00005)",
    d: "M-488533-158734h977066l-790463 574305L0-513674l301930 929245z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "translate(-70 -121.244)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "translate(-121.244 -70)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "translate(-140)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "scale(-1 1)",
    width: "100%",
    height: "100%"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTj);
export default __webpack_public_path__ + "static/media/tj.7eb224f76c59224b9138382e5d49f747.svg";
export { ForwardRef as ReactComponent };